import React from 'react';
import { CONNECTION_TREND_DAY_OPTIONS } from '../../lib/dashboardTrendDays';
import {
  type ConnectionTrendDayOption,
  formatDashboardRangeOption,
} from '../../lib/connectionDashboard';
import { useDashboardTrendDays } from '../../context/DashboardChartHoverContext';

const DashboardTrendRangeSelect: React.FC = () => {
  const { dayCount, setDayCount } = useDashboardTrendDays();

  return (
    <div className="hidden lg:flex items-center gap-2">
      <label
        htmlFor="dashboard-trend-range"
        className="text-xs font-medium text-gray-600 dark:text-gray-400"
      >
        Chart range
      </label>
      <select
        id="dashboard-trend-range"
        value={dayCount}
        onChange={(e) => setDayCount(Number(e.target.value) as ConnectionTrendDayOption)}
        className="text-xs rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 px-2 py-1 focus:outline-none focus:ring-1 focus:ring-emerald-500"
        aria-label="Dashboard chart time range for all charts"
      >
        {CONNECTION_TREND_DAY_OPTIONS.map((range) => (
          <option key={range} value={range}>
            {formatDashboardRangeOption(range)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DashboardTrendRangeSelect;
